module.exports = __webpack_public_path__ + "0552cb70edf2c0e3c320b499b4e83280.png";